import React from 'react'

import { Emph, PageContainer } from '../components/Common'
import { Card, Divider, Flex, Heading, Link, Text } from '@aws-amplify/ui-react'
import { MyTmpVpnClient } from '@mytmpvpn/mytmpvpn-client'
import { PeanutsPacksGrid } from '../components/PeanutsPackCards'


function HeroSection() {
  return (
    <Flex direction="column" alignItems="center" padding="1rem 1rem 0" gap="0.75rem">
      <Heading level={2} textAlign="center">
        MyTmpVpn
      </Heading>
      <Text textAlign="center" fontWeight="bold" fontStyle="italic">
        The pay-as-you-go VPN
      </Text>
      <Flex direction="row" wrap="wrap" justifyContent="center" gap="1rem" paddingTop="0.5rem">
        <Flex direction="column" alignItems="center" gap="0.25rem">
          <Text fontSize="xl">🔒</Text>
          <Text fontWeight="bold" fontSize="small">Secure</Text>
          <Text fontSize="xs" color="font.secondary"><Link isExternal href="https://wireguard.com/install">WireGuard</Link></Text>
        </Flex>
        <Flex direction="column" alignItems="center" gap="0.25rem">
          <Text fontSize="xl">🛡️</Text>
          <Text fontWeight="bold" fontSize="small">Isolated</Text>
          <Text fontSize="xs" color="font.secondary">Own server, no SSH</Text>
        </Flex>
        <Flex direction="column" alignItems="center" gap="0.25rem">
          <Text fontSize="xl">⏱️</Text>
          <Text fontWeight="bold" fontSize="small">Temporary</Text>
          <Text fontSize="xs" color="font.secondary">Auto-destroyed</Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

function PeanutsExplainer() {
  return (
    <Card variation="outlined" borderRadius="medium" padding="1rem">
      <Flex direction="column" gap="0.5rem" alignItems="center">
        <Heading level={4} textAlign="center">🥜 What are peanuts?</Heading>
        <Text textAlign="center" fontSize="small">
          Peanuts are credits that power your VPN. You assign peanuts when creating a VPN,
          and they are consumed over time. When peanuts run out, the VPN is terminated.
        </Text>
        <Text textAlign="center" fontSize="small" fontWeight="bold">
          No subscription. Buy once, use anytime.
        </Text>
        <Text textAlign="center" fontSize="small" color="font.tertiary">
          💸 Not satisfied? We refund your unused peanuts. No questions asked.
        </Text>
      </Flex>
    </Card>
  )
}

function CtaSection() {
  return (
    <Card backgroundColor="background.secondary" borderRadius="medium" padding="1rem">
      <Flex direction="column" alignItems="center" gap="0.5rem">
        <Text textAlign="center" fontSize="large" fontWeight="bold">
          <Link href="/signup">
            Sign up and get <Emph>10 free peanuts!</Emph>
          </Link>
        </Text>
        <Text textAlign="center" fontSize="small" color="font.secondary">
          Enough to try a VPN session right away.
        </Text>
      </Flex>
    </Card>
  )
}

export function Welcome({ client }: { client: MyTmpVpnClient }) {
  return (
    <PageContainer>
      <HeroSection />
      <CtaSection />
      <PeanutsExplainer />
      <Divider />
      <Heading level={3} textAlign="center">Pricing Plans</Heading>
      <PeanutsPacksGrid client={client} />
      <Divider />
      <Heading level={3} textAlign="center">Available Locations</Heading>
      <Text textAlign="center" fontSize="small">
        VPNs in <Link href="/locations">multiple regions worldwide</Link>. Pick the closest for best performance.
      </Text>
      <Text textAlign="center" fontSize="small" color="font.secondary" paddingBottom="1rem">
        Questions? Read the <Link href="/faq">FAQ</Link> or <Link href="/contactus">contact us</Link>.
      </Text>
    </PageContainer>
  )
}
